import { MentionsPlugin } from "../../../sked-editor/social-mention/mention-plugin";
import { isSuggestOptionTag } from "../../utils/autocomplete";
import { SuggestFunc } from "../types";
import { SkedMentionBox, SkedMentionItem } from "./sked-mention-box";
import { useRef } from "react";
import { MentionPluginInstance } from "../../../sked-editor/social-mention/types";

export const HashtagSearchPlugin = ({
  lookupFunc,
  onRemoveItem,
}: {
  lookupFunc: SuggestFunc;
  onRemoveItem: (item: SkedMentionItem) => Promise<void>;
}) => {
  const pluginRef = useRef<MentionPluginInstance>(null);
  return (
    <MentionsPlugin
      pluginRef={pluginRef}
      menuBoxBehavior={{
        nodeConversion: {
          type: "plain-text",
          convertFunc: (item) => `#${item.key}`,
          trailingSpace: true,
        },

        dataFetcher: async (
          lookupText: string | null | undefined
        ): Promise<SkedMentionItem[]> => {
          const rs = await lookupFunc(lookupText || "");
          return rs
            .filter((c) => isSuggestOptionTag(c))
            .filter((c) => c.value.length > 1)
            .map((c) => ({ key: c.value, displayName: `#${c.value}` }));
        },
        renderMenuBox: (props, { lookupText }) => {
          return (
            <SkedMentionBox
              {...props}
              onRemoveItem={async (item) => {
                await onRemoveItem(item);
                pluginRef.current?.reload();
              }}
              headingText="Previously used hashtags"
              infoTooltip="Only previously used hashtags are shown. Enter the correct hashtag to add it."
              highlightBehavior={{
                matchingOn: "start",
                searchText: lookupText ? `#${lookupText}` : undefined,
              }}
              displayConfig={{
                showRemove: true,
              }}
            />
          );
        },

        maxItemsToShow: 100,
      }}
      lookupConfig={{
        allowWhitespace: false,
        trigger: "#",
        minLength: 0,
        maxLength: 50,
        typeDebounceTime: 200,
      }}
    />
  );
};
